export default () => ({
  type: 'function',
  processor: 'mustache',
  provider: () => `
<div>
  <p class="text-weight-bold q-mt-lg">
    <span data-jcs-element="info__journey__action" class="info-item__value">...</span>
  </p>
  <div class="q-mb-md">
    <p class="q-mt-sm">Before you start, please make sure:</p>
    <p class="q-mt-sm">1) Your driver's licence is up to date</p>
    <p class="q-mt-sm">2) Take photo in a well-lit flat surface</p>
  </div>

  <!-- UI for displaying the camera selection -->
  <form class="q-mb-md">
    <select data-jcs-element="camera__select" class="control control--select"></select>
  </form>

  <!-- Dashed primary container -->
  <div class="bdr-a-primary bdr-dashed bg-primary-pale rounded-borders-lg q-pa-sm">
    <!-- UI for displaying the camera view finder -->
    <div class="help-container relative-position">
      <div class="mx-h rounded-borders-lg relative-position">
        <canvas data-jcs-element="camera__viewfinder" class="camera-viewfinder"></canvas>
        <div data-jcs-element="overlay_viewfinder" class="camera-viewfinder--overlay--transparent">
          <div class="loading-animation-container" data-jcs-element="loading-animation" style="display:none">
          </div>
        </div>
      </div>
    </div>

    <!-- Message for action instructions -->
    <div data-jcs-element="info__journey__action__container" class="q-my-md text-weight-medium text-center">
      <span data-jcs-element="info__journey__action__text"></span>
    </div>

    <!-- Button to take the photo -->
    <form class="camera-capture--container bdr-a-primary-lg">
      <input data-jcs-element="camera__capture" class="camera-capture--button bg-primary" type="button" />
    </form>
  </div>

  <!-- UI for switching to smart capture -->
  <div class="q-mt-md" data-jcs-element="camera__manual__capture">
    <label class="bg-application-primary button text-weight-medium full-width" aria-label="switch">
      <input hidden type="checkbox" checked/>
      <p class="text-white text-weight-medium">Switch to Smart Camera Mode</p>
    </label>

    <div class="row justify-center items-center full-width relative-position or-container q-mt-lg">
      <div class="or-container-line"></div>
      <p class="q-px-md text-grey-6">OR</p>
      <div class="or-container-line"></div>
    </div>
  </div>
</div>
  `
});
